import {
  IOS_VER_15,
  IPHONE_USER_AGENT_REGS,
  MOBILE_USER_AGENT_REGS,
  VR_USER_AGENT_REGS
} from './const';
import {setLoggedInStatusToggle} from './dataOps';

/**
 */
export const hel_isChrome = () => {
  return window.navigator.userAgent.toLowerCase().indexOf('chrome') !== -1;
};

export const hel_getChromeVersion = (): number => {
  if (!hel_isChrome()) return 0;

  const v = window.navigator.userAgent.match(/Chrome\/([0-9.]+)/);
  if (v === null || v === undefined) return 0;

  if (v[1] !== undefined) {
    return parseInt(v[1], 10);
  }

  return 0;
};

/**
 */
export const hel_isAndroid = () => {
  return window.navigator.userAgent.toLowerCase().indexOf('android') !== -1;
};

export const hel_isMobile = (): boolean => {
  if (hel_isiPad()) {
    return true;
  }

  return window.navigator.userAgent.search(MOBILE_USER_AGENT_REGS) !== -1;
};

export const hel_isiPad = (): boolean => {
  const agent = window.navigator.userAgent.toLowerCase();
  return (
    agent.indexOf('ipad') > -1 || (agent.indexOf('macintosh') > -1 && 'ontouchend' in document)
  );
};

/** VR機器(現状Quest2/Quest3)かどうか */
export const hel_isVRDevice = (): boolean => {
  return window.navigator.userAgent.search(VR_USER_AGENT_REGS) !== -1;
};

export const hel_isiPhone = (): boolean => {
  if (hel_isiPad()) {
    return true;
  }

  return window.navigator.userAgent.search(IPHONE_USER_AGENT_REGS) !== -1;
};

export const hel_isMac = (): boolean => {
  const agent = window.navigator.userAgent.toLowerCase();
  return agent.indexOf('macintosh') > -1;
};

export const hel_isSafari = (): boolean => {
  const v = window.navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
  if (v === null || v === undefined) return false;

  return true;
};

export const hel_isFirefox = (): boolean => {
  return window.navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
};

// Android版LINEのIn-App Browserか判定
export const hel_isAndroidLineIAB = (): boolean => {
  const ua = navigator.userAgent;

  // Androidかどうかをチェック
  const isAndroid = ua.includes('Android');

  // LINEのIn-App Browserかどうかをチェック（末尾が /IAB）
  const isLineIAB = /Line\/[\d.]+\/IAB/.test(ua);

  return isAndroid && isLineIAB;
};

// LINEのミニアプリか判定
export const hel_isLineMiniApp = (): boolean => {
  const ua = navigator.userAgent || '';
  return ua.includes('LIFF') && ua.includes('Line');
};

Object.assign(globalThis, {
  hel_isVRDevice,

  hel_isiPhone,

  hel_isMac,

  hel_isSafari,

  hel_isFirefox
});

export const hel_getiOSVersion = (): number => {
  if (/iP(hone|od|ad)/.test(window.navigator.platform)) {
    const v = window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    if (!v) {
      throw new Error(
        `Failed to parse iOS version: expected navigator.appVersion to contain “OS <major>_<minor>[_<patch>]”, got “${window.navigator.appVersion}”.`
      );
    }
    if (!v[1] || !v[2]) throw new Error();
    return parseInt(v[1], 10) * 100 + parseInt(v[2], 10);
  }
  return 0;
};

export const hel_getMacOSVersion = (): number => {
  if (!hel_isMac() && !hel_isiPad()) return 0;

  const v = window.navigator.userAgent.match(/Version\/(\d+).(\d+)/)!;
  if (v === null || v === undefined) return 0;

  if (v[1] && v[2]) {
    return parseInt(v[1], 10) * 100 + parseInt(v[2], 10);
  }

  return 0;
};

/**
 * 未使用
 */
export const hel_isiOS14Under = (): boolean => {
  if (!hel_isiPhone()) {
    return false;
  }
  return hel_getiOSVersion() < IOS_VER_15;
};

//
export const hel_isLangJa = (): boolean => {
  const browserLang =
    (window.navigator.languages && window.navigator.languages[0]) || window.navigator.language;

  return browserLang === 'ja' || browserLang === 'ja-JP';
};

// 直接開かれたか、リンクによるページ遷移で移動してきたか
export const hel_isDirectPageAccess = (): boolean => {
  return !document.referrer;
};

/**
 * 未使用
 */
export const hel_setLogined = (logined: boolean) => setLoggedInStatusToggle(logined);

/**
 * @remarks
 * macM1環境用RenderTypes返却関数
 */
export const defineYourRenderTypes = () => {
  // TODO 現在手動運用。macM1@Local環境テスト時仕様
  //      dotEnvパッケージを.envにて運用を検討

  // return ['webgl', 'experimental-webgl', 'webgl2'];
  return ['webgl', 'experimental-webgl'];
};
